import React from "react";
import { Empty, Table } from "antd";
import { ColumnProps } from "antd/es/table";
import {
    GroupItem,
    GroupPersonItem,
    TeamCanType
} from "../../../../../../../API/teams";
import Style from "./index.module.scss";
import useDeviceType from "../../../../../../../Utils/useDeviceType";
import mobileTd from "../MobileTd";

interface Prop {
    data: GroupItem[];
}
const Index = ({ data }: Prop) => {
    const { isPC, isMobile } = useDeviceType();

    const columns: ColumnProps<GroupPersonItem>[] = [
        {
            title: "序号",
            key: "index",
            align: "center",
            width: 100,
            render: (text, item, index) => index + 1
        },
        {
            title: "姓名",
            dataIndex: "name",
            render: (text, item) => {
                return item.isGroupLeader === TeamCanType.yes ? (
                    <span className={Style.leader}>{text} (组长)</span>
                ) : (
                    text
                );
            }
        },
        {
            title: "学号",
            dataIndex: "memberNo"
        },
        {
            title: "学院",
            dataIndex: "college"
        }
    ];

    return (
        <>
            <div className={Style.pd}>
                {data?.map((tableData, index) => (
                    <div className={Style.bg} key={tableData.id}>
                        <span className={Style.title}>
                            {tableData.groupName} ({tableData.memberCount}
                            人)
                        </span>
                        {isPC && (
                            <Table
                                bordered
                                rowKey="id"
                                dataSource={tableData.groupMemberList}
                                columns={columns}
                                pagination={false}
                            />
                        )}
                        {isMobile && (
                            <table className={Style.mobileTable}>
                                {tableData.groupMemberList?.length === 0 && (
                                    <Empty />
                                )}
                                {tableData.groupMemberList.map(item => (
                                    <tr key={item.id}>
                                        <td width="50%">{mobileTd(item)}</td>
                                        <td>{item.college}</td>
                                    </tr>
                                ))}
                            </table>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default Index;
